import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './branch-locator.component.scss';
import * as _ from 'lodash';
var BranchLocator = /** @class */ (function (_super) {
    tslib_1.__extends(BranchLocator, _super);
    function BranchLocator(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('mapInitialised', null, _this.setMapOptions.bind(_this));
        return _this;
    }
    BranchLocator.prototype.init = function () {
        var _this = this;
        this.activeFilters = [];
        this.mapMarkers = [];
        this.endpoint = this.element.getAttribute('data-endpoint');
        this.distanceIcon = this.element.getAttribute('data-distanceIcon');
        this.markerIcon = this.element.getAttribute('data-markerIcon');
        this.http.get(this.distanceIcon)
            .then(function (response) {
            _this.distanceSVG = response.data;
        });
        if ("geolocation" in navigator) {
        }
        else {
            /* geolocation IS NOT available */
            Array.from(this.element.querySelectorAll('.js-location')).map(function (item) {
                item.classList.add('button--disabled');
            });
        }
    };
    BranchLocator.prototype.bindEvents = function () {
        var _this = this;
        Array.from(this.element.querySelectorAll('.js-location')).map(function (item) {
            item.addEventListener("click", function (e) {
                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        _this.currentLocation = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        console.log(position);
                        _this.map.setCenter(_this.currentLocation);
                        _this.map.setZoom(13);
                    });
                }
            });
        });
        document.getElementsByClassName('js-search')[0].addEventListener('click', function (e) {
            e.preventDefault();
            _this.searchTerm = document.getElementById('branch-locator__search-input').value;
            _this.http.get(_this.endpoint + ("?searchTerm=" + _this.searchTerm)).then(function (response) {
                if (response.data.length > 0) {
                    _this.searchResults = response.data;
                    var markers = _.map(response.data, function (loc) {
                        return {
                            coordinates: loc.coordinates,
                            icon: _this.markerIcon,
                            title: loc.title,
                            info: loc.address
                        };
                    });
                    _this.setMarkers(markers);
                    document.querySelector('.branch-locator__results__content').innerHTML = "";
                    var docfragment_1 = document.createDocumentFragment();
                    var index_1 = 0;
                    response.data.forEach(function (item) {
                        docfragment_1.appendChild(_this.renderLocation(item, index_1));
                        index_1++;
                    });
                    document.getElementsByClassName('branch-locator__results__content')[0].appendChild(docfragment_1);
                    document.getElementsByClassName('branch-locator__results')[0].classList.remove('branch-locator__results--hide');
                    Array.from(_this.element.querySelectorAll('.branch-locator__message')).map(function (item) {
                        item.classList.remove('d-none');
                        item.classList.remove('d-lg-block');
                        item.classList.add('branch-locator__message--hide');
                    });
                }
                else {
                    _this.searchResults = [];
                    Array.from(_this.element.querySelectorAll('.branch-locator__message')).map(function (item) {
                        item.classList.remove('d-none');
                        item.classList.remove('d-lg-block');
                        item.classList.add('branch-locator__message--hide');
                    });
                    document.getElementsByClassName('branch-locator__notfound')[0].classList.add('branch-locator__notfound--show');
                    document.getElementsByClassName('branch-locator__notfound__term')[0].innerHTML = "\"" + _this.searchTerm + "\"";
                }
            });
        });
        var filters = this.element.querySelectorAll('.js-filter');
        for (var index = 0; index < filters.length; index++) {
            this.activeFilters.push(filters[index].getAttribute('data-filter'));
        }
        Array.from(this.element.querySelectorAll('.js-filter')).map(function (item) { return item.addEventListener('click', function (event) {
            _this.filterClick(event);
        }); });
        document.addEventListener('click', function (e) {
            var composedPath = function (el) {
                var path = [];
                while (el) {
                    path.push(el);
                    if (el.tagName === 'HTML') {
                        path.push(document);
                        path.push(window);
                        return path;
                    }
                    el = el.parentElement;
                }
            };
            var path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target);
            var hasClass = function (cls) {
                return _.filter(path, function (p) {
                    var exists = false;
                    _.each(p.classList, function (cl) {
                        if (cl === cls) {
                            exists = true;
                        }
                    });
                    if (p.classList && exists) {
                        return p;
                    }
                })[0];
            };
            if (hasClass('branch-locator-item')) {
                _this.expandLocation(hasClass('branch-locator-item'));
            }
        }, false);
    };
    BranchLocator.prototype.callback = function (response, status) {
        console.log(response, status);
        // See Parsing the Results for
        // the basics of a callback function.
    };
    BranchLocator.prototype.filterClick = function (e) {
        var _this = this;
        var filter = e.srcElement.getAttribute('data-filter');
        var filterIndex = this.activeFilters.indexOf(filter);
        if (filterIndex > -1) {
            this.activeFilters.splice(filterIndex, 1);
        }
        else {
            this.activeFilters.push(filter);
        }
        var filteredResults = _.filter(this.searchResults, function (res) {
            return _.some(res.services, function (el) {
                return _.includes(_this.activeFilters, el);
            });
        });
        this.renderFiltered(_.take(filteredResults, 4));
    };
    BranchLocator.prototype.renderFiltered = function (datasource) {
        var _this = this;
        document.getElementsByClassName('branch-locator__results__content')[0].innerHTML = "";
        var markers = _.map(datasource, function (loc) {
            return {
                coordinates: loc.coordinates,
                icon: _this.markerIcon,
                title: loc.title,
                info: loc.address
            };
        });
        this.setMarkers(markers);
        document.querySelector('.branch-locator__results__content').innerHTML = "";
        var docfragment = document.createDocumentFragment();
        var index = 0;
        datasource.forEach(function (item) {
            docfragment.appendChild(_this.renderLocation(item, index));
            index++;
        });
        document.getElementsByClassName('branch-locator__results__content')[0].appendChild(docfragment);
    };
    BranchLocator.prototype.setMarkers = function (markers) {
        var _this = this;
        for (var i = 0; i < this.mapMarkers.length; i++) {
            this.mapMarkers[i].setMap(null);
        }
        var mIndex = 0;
        var _loop_1 = function (marker) {
            var markerInstance = new google.maps.Marker({
                position: marker.coordinates,
                icon: marker.icon,
                title: marker.title,
                map: this_1.map,
                zIndex: mIndex
            });
            this_1.mapMarkers.push(markerInstance);
            var infoWindow = new google.maps.InfoWindow({
                content: marker.info
            });
            markerInstance.addListener('click', function (e) {
                infoWindow.open(_this.map, markerInstance);
                console.log(markerInstance);
                _this.expandLocation(document.querySelector(".branch-locator-item[data-index='" + markerInstance.getZIndex() + "']"));
            });
            mIndex++;
        };
        var this_1 = this;
        for (var _i = 0, markers_1 = markers; _i < markers_1.length; _i++) {
            var marker = markers_1[_i];
            _loop_1(marker);
        }
    };
    BranchLocator.prototype.setMapOptions = function (event, mapData) {
        this.map = mapData.map;
        /* const infowindow = new google.maps.InfoWindow({
            content: "<strong>test</strong>"
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open(map,marker);
        });

        google.maps.event.addDomListener(window, 'resize', function() {
            map.setCenter(mapLatLng);
        }); */
    };
    BranchLocator.prototype.expandLocation = function (element) {
        var locations = document.getElementsByClassName('branch-locator-item');
        for (var i = 0; i < locations.length; i++) {
            locations[i].classList.remove('branch-locator-item--open');
        }
        element.classList.add('branch-locator-item--open');
        this.map.setCenter(this.searchResults[element.getAttribute('data-index')].coordinates);
        this.map.setZoom(13);
    };
    BranchLocator.prototype.renderLocation = function (input, index) {
        var contact = "";
        var hours = "";
        var services = "";
        input.contact.forEach(function (element) {
            contact += "\n                <span class=\"branch-locator-item__info\">\n                    " + element + "\n                </span>\n            ";
        });
        input.operatingHours.forEach(function (element) {
            hours += "\n                <span class=\"branch-locator-item__info\">\n                    " + element + "\n                </span>\n            ";
        });
        var serviceCount = 0;
        input.services.forEach(function (element) {
            serviceCount++;
            if (serviceCount == input.services.length) {
                services += element;
            }
            else {
                services += element + ", ";
            }
        });
        var output = "\n\t\t\n\t\t\t<div class=\"branch-locator-item " + (index == 0 ? 'branch-locator-item--open' : '') + "\"\n                data-component=\"branch-locator-item\"\n                data-index=\"" + index + "\">\n\t\t\t\t\n\t\t\t\t<div class=\"branch-locator-item__title\">\n\n\t\t\t\t\t<div class=\"title title--module-sub-title\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"branch-locator-item__distance\">\n\n\t\t\t\t\t\t<i class=\"icon\">\n\t\t\t\t\t\t\t" + this.distanceSVG + "\n\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t<span class=\"branch-locator-item__distance__title title title--entrance\">\n\t\t\t\t\t\t\t10,3 km\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"branch-locator-item__content\">\n\t\t\t\t\t\t\n\t\t\t\t\t<p>\n                        " + input.address + "\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"row\">\n\n\t\t\t\t\t\t<div class=\"col-6\">\n\n\t\t\t\t\t\t\t<div class=\"title title--notes\">\n\t\t\t\t\t\t\t\tTelephone\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t" + contact + "\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"col-6\">\n\n\t\t\t\t\t\t\t<div class=\"title title--notes\">\n\t\t\t\t\t\t\t\topening hours\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t" + hours + "\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"col-6\">\n\n\t\t\t\t\t\t\t<div class=\"title title--notes\">\n\t\t\t\t\t\t\t\tservices\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<span class=\"branch-locator-item__info\">\n\t\t\t\t\t\t\t\t" + services + "\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<a class=\"button button--large\" href=\"http://maps.google.com/maps?q=" + input.coordinates.lat + "," + input.coordinates.lng + "\" target=\"_blank\">\n\t\t\t\t\t\n\t\t\t\t\t\tGet Directions\n\t\t\t\t\n\t\t\t\t\t</a>\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t\n\t\t";
        return document.createRange().createContextualFragment(output);
    };
    return BranchLocator;
}(Base));
export { BranchLocator };



//////////////////
// WEBPACK FOOTER
// ./components/branch-locator/branch-locator.component.ts
// module id = 149
// module chunks = 0